export default {
    '--full-color': '#F987A8',
    '--light-color': 'rgba(249, 135, 168, 0.6)',
    '--main-content-grid': '#F987A822',
    '--grid-view-background': 'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)',
    '--card-view-background': 'linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%)',
    '--title-color': 'rgba(0, 0, 0, 0.87)',
    '--icon-color': '#F987A8',
    '--grid-bg-color': 'rgba(252, 228, 236, 0.65)',
    '--text-input-bg-color': 'rgba(252, 228, 236, 0.75)',
    '--avatar-background': 'linear-gradient(to right, #FCE4EC, #F987A8)',
    '--reserve-background': 'linear-gradient(234deg, #F987A8 20%, #E96B94 100%)',
    '--icon-theme-filter': 'invert(69%) sepia(27%) saturate(1070%) hue-rotate(295deg) brightness(101%) contrast(96%)',
    '--login-layout-background': 'linear-gradient(234deg, #F987A822 20%, #E96B9422 100%)',
    '--lbl-focused-color': '#F987A8',
    '--focused-fieldset-color': 'rgba(249, 135, 168, 0.65)',
    '--input-border-error-color': '#F04924',
    '--checkbox-color': '#F987A8',
    '--color-white': '#FFFFFF',
    '--txt-disabled': '#FFFFFF',
    '--txt-success': '#E96B94',
    '--txt-error': 'rgba(255, 125, 98, 0.7)',
    '--disabled-bg': 'rgba(249, 135, 168, 0.05)',
    '--txt-default': '#797979',
    '--link-color': '#E96B94',
    '--txt-gray-color': '#797979',
    '--active-box-background': 'linear-gradient(180deg, #F987A8 0%, #E96B94 100%)',
    '--scrollbar-bg': 'linear-gradient(200deg, #F987A8, #E96B94)',
    '--active-item-background-color': 'rgba(252, 228, 236, 0.75)',
    '--input-number-border-color': '#FCE4EC',
    '--input-number-focused-border-color': '#F987A8',
    '--btn-bg-hover': '#E96B94',
    '--btn-success-background': 'linear-gradient(273.72deg, #F987A8 5.88%, #E96B94 128.9%)',
    '--btn-success-border-color': '#F987A8',
    '--btn-gray-background-color': '#A4A4A4',
    '--btn-gray-border-color': '#AAAAAA',
    '--btn-disabled-border-color': '#E8E8E8',
    '--tab-background': 'linear-gradient(180deg, #F987A8 0%, #E96B94 100%)',
    '--tab-indicator-background': 'transparent',
    '--tab-shadow': '0 4px 8px 1px rgba(249, 135, 168, 0.16)',
    '--btn-shadow': '0 4px 18px 1px rgba(249, 135, 168, 0.22)',
    '--card-shadow': '0 4px 6px 0 rgba(249, 135, 168, 0.10)',
    '--input-background-color': '#FFF7F2',
    '--select-border-color': 'rgba(89, 89, 89, 0.5)',
    '--select-bg-color': 'rgba(252, 228, 236, 0.45)',
    '--select-text-color': 'rgba(0, 0, 0, 0.9)',
    '--loading-color': '#F987A8',
    '--redial-gradient': '#F987A8',
}